import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Button } from '@mui/material';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { useTranslation } from '@/src/i18n';
import { isDocavenueClient, isRdvEnabled } from '@/components/utils/card';

const RDVButton = ({ card }: { card: CardHcd }) => {
  const { t } = useTranslation();
  const router = useRouter();
  if (!isDocavenueClient(card)) return null;
  const centerId = card.center?.id;
  const query = { ...router.query };
  if (centerId) query.centerId = centerId;
  return (
    <div className="profile-button killondesk">
      {isRdvEnabled(card) ? (
        <Link
          href={{
            pathname: `${card.url}/rdv`,
            query,
          }}
          passHref
          legacyBehavior
        >
          <Button
            variant="contained"
            color="secondary"
            data-cy="btn-rdv-only-mobile"
          >
            {t('get-appointment')}
          </Button>
        </Link>
      ) : (
        <Button disabled variant="contained" color="secondary">
          {t('closest_availability_none_short')}
        </Button>
      )}
    </div>
  );
};

export default RDVButton;
